var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var DualRowPackageData = require('./dualRowPackageData.js');

var Sot23Data = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);
};

lib_core.inherit(Sot23Data, DualRowPackageData);
lib_core.JsonParser.registerClass(Sot23Data, "Sot23Data");

module.exports = Sot23Data;

Sot23Data.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var hPitch = self.component.C,
        vPitch = self.verticalPinPitch(),
        motif = self.getMotif(),
        leftPadCount = self.component.padsPerSide[0],
        rightPadCount = self.component.padsPerSide[1],
        totalPadCount = leftPadCount + rightPadCount,
        rowIdx,
        idx;

    //left pads
    for (idx = 0; idx < leftPadCount; idx++) {
        rowIdx = idx % leftPadCount;

        var pad = motif.clone();
        
        //SOT23-3 has pin pitch of (2 * vPitch) in left side
        pad.move(new lib_geometry.Coord(-0.5 * hPitch, ((leftPadCount - 1) / 2 - rowIdx) * ((totalPadCount === 3 || totalPadCount === 4) ? 2 : 1) * vPitch));
        pads.push(pad);
    }

    //right pads
    for (idx = 0; idx < rightPadCount; idx++) {
        rowIdx = rightPadCount - 1 - idx % rightPadCount;

        var pad = motif.clone();
        
        //SOT23-5 has pin pitch of (2 * vPitch) in right side
        pad.move(new lib_geometry.Coord(0.5 * hPitch, ((rightPadCount - 1) / 2 - rowIdx) * ((totalPadCount === 5 || totalPadCount === 4) ? 2 : 1) * vPitch));
        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data (LineData)
 */
Sot23Data.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = this.getBodyForSilkscreen();

    var leftFirstPad = pads[0],
        leftLastPad = (this.horizontalPadCount() === 5) ? pads[2] : pads[this.component.padsPerSide[0] - 1];

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(leftFirstPad, body));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////

	var topEdge = leftFirstPad.getPos().y + leftFirstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance;
    var botEdge = leftLastPad.getPos().y - leftLastPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance;
    var pathData;

	if(this.horizontalPadCount() !== 3) {
        //if the top edge of first pad (with clearence) crosses the top edge of assembly outline (with clearence) draw lines except side lines with clearance
        if (topEdge + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topEdge + IPCRules.silkscreenStrokeWidth / 2), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, topEdge + IPCRules.silkscreenStrokeWidth / 2), PathType.LINE));
            silkscreen.push(pathData);

            pathData = pathData.clone();
            pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
            silkscreen.push(pathData);
        } else {
            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topEdge), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, body.height / 2), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, topEdge), PathType.LINE));
            silkscreen.push(pathData);

            pathData = pathData.clone();
            pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
            silkscreen.push(pathData);
        }
	} else {//SOT23-3
		var rightPad = pads[this.horizontalPadCount() - 1];

        //if first left pad top edge crosses (with clearance) assembly outline top edge (with clearance) draw only top, down and right side lines
        if (topEdge + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topEdge + IPCRules.silkscreenStrokeWidth / 2), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, topEdge + IPCRules.silkscreenStrokeWidth / 2), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, rightPad.getPos().y + rightPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
            silkscreen.push(pathData);

            pathData = pathData.clone();
            pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
            silkscreen.push(pathData);
        } else {
            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topEdge), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, body.height / 2), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, rightPad.getPos().y + rightPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
            silkscreen.push(pathData);

            pathData = pathData.clone();
            pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
            silkscreen.push(pathData);
        }
	}

	return silkscreen;
};
